import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { config } from './firebase-config';


firebase.initializeApp(config.prod);

export const auth = firebase.auth();

export const db = firebase.firestore();

if (location.hostname === "localhost") {
  db.settings({
    host: "localhost:8080",
    ssl: false
  });
}

export const fb = firebase;
